import { useDispatch } from 'react-redux';
import { showAlert } from '../../../../../features/slices/applicationSlice';
import { useTranslation } from 'react-i18next';

interface ShowConfirmationAlert {
    confirmAction: () => void;
    cancelAction: () => void;
    currentVisitsNumber: number;
}

interface ShowDifferentPreventorAlert {
    confirmAction: () => void;
    cancelAction: () => void;
}

const VISIT_COUNT_BEFORE_ALERT = 0; //Valor para mostrar la alerta que avisa al usuario la cantidad de visitas asignadas actuales de un preventor.

const useAlerts = () => {
    const dispatch = useDispatch();
    const { t: translate } = useTranslation('visitas');

    const showConfirmPreventorAssignationAlert = ({
        confirmAction,
        cancelAction,
        currentVisitsNumber
    }: ShowConfirmationAlert) => {
        dispatch(
            showAlert({
                title:
                    currentVisitsNumber > VISIT_COUNT_BEFORE_ALERT
                        ? `${translate('drawers.alerts.assignPreventor.title', {
                              count: currentVisitsNumber
                          })}`
                        : translate('drawers.alerts.assignPreventor.noAssignedVisitsTittle'),
                message: translate('drawers.alerts.assignPreventor.message'),
                icon: 'info',
                confirmText: translate('drawers.alerts.assignPreventor.confirmText'),
                cancelText: translate('drawers.alerts.assignPreventor.cancelText'),
                confirmAction: confirmAction,
                cancelAction: cancelAction
            })
        );
    };

    const showConfirmPreventorRessignationAlert = ({
        confirmAction,
        cancelAction,
        currentVisitsNumber
    }: ShowConfirmationAlert) => {
        dispatch(
            showAlert({
                title:
                    currentVisitsNumber > VISIT_COUNT_BEFORE_ALERT
                        ? `${translate('drawers.alerts.reassignPreventor.title', {
                              count: currentVisitsNumber
                          })}`
                        : translate('drawers.alerts.reassignPreventor.noAssignedVisitsTittle'),
                message: translate('drawers.alerts.reassignPreventor.message'),
                icon: 'info',
                confirmText: translate('drawers.alerts.reassignPreventor.confirmText'),
                cancelText: translate('drawers.alerts.reassignPreventor.cancelText'),
                confirmAction: confirmAction,
                cancelAction: cancelAction
            })
        );
    };

    const showDifferentProviderAlert = ({
        confirmAction,
        cancelAction
    }: ShowDifferentPreventorAlert) => {
        dispatch(
            showAlert({
                title: translate('drawers.alerts.differentProvider.title'),
                message: translate('drawers.alerts.differentProvider.message'),
                icon: 'info',
                confirmText: translate('drawers.alerts.differentProvider.confirmText'),
                cancelText: translate('drawers.alerts.differentProvider.cancelText'),
                confirmAction: confirmAction,
                cancelAction: cancelAction
            })
        );
    };
    return {
        showConfirmPreventorAssignationAlert,
        showConfirmPreventorRessignationAlert,
        showDifferentProviderAlert
    };
};

export default useAlerts;
